import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { sessionReducer } from 'hub-redux-auth';

import appReducer from './application';
import dashboard from './dashboard';
import reseller from './reseller';
import masterData from './masterData';
import timeline from './timeline';
import documents from './documents';
import filter from './filter';
import { rootReducer as partnerAppReducer } from '@store/rootDuck';

const rootReducer = combineReducers({
  partnerApp: partnerAppReducer,
  reseller,
  dashboard,
  masterData,
  session: sessionReducer,
  filter,
  form: formReducer,
  app: appReducer,
  timeline,
  documents,
});

export default rootReducer;
